import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { InjectionToken } from '@angular/core';
import {SERVER_TOKEN} from '../../constants/tokens';


@Injectable({
  providedIn: 'root',
})
export class CookieTokenService {
  private token: string | null = null;

  constructor(
    @Inject(SERVER_TOKEN) private serverToken: string | null,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    if (isPlatformServer(this.platformId)) {
      this.token = this.serverToken; // Token from server-side
    } else if (isPlatformBrowser(this.platformId)) {
      this.token = this.getBrowserToken(); // Token from browser cookies
    }
  }

  private getBrowserToken(): string | null {
    const match = document.cookie.match(new RegExp('(^| )auth-token=([^;]+)'));
    return match ? match[2] : null;
  }

  getToken(): string | null {
    return this.token;
  }
  setToken(token: string): void {
    this.token = token;

    if (isPlatformBrowser(this.platformId)) {
      // Update the token in browser cookies
      document.cookie = `auth-token=${token}; path=/; secure; samesite=strict;`;
    }
    // On the server, you can optionally add logic to update the token for the current request context.
  }
}
